import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationSubScriptionService {

  constructor(private http: HttpClient) { }

  /**
   * Get Notify Options for DropDown
   */
  getNotifyEventOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/notify/eventOptions`;
    return this.http.get(url);
  }

  /**
   * Get Tenant Options for DropDown
   */
  getTenantOptions(): Observable<any> {
    const url = `${environment.authUrl}/tenant`;
    return this.http.get(url);
  }

  /**
   * Get Facility Options for DropDown
   */
  getFacilityOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility`;
    return this.http.get(url);
  }

  /**
   * Get Forwarder Options for DropDown
   */
  getForwarderOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/forwarder`;
    return this.http.get(url);
  }

  /**
   * Get Customer Options for DropDown
   */
  getCustomerOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/Customer/Options`;
    return this.http.get(url);
  }

  /**
   * Get Org Options for DropDown
   */
   getTenantOrgOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/TenantOrg/getTenantOrgOptions`;
    return this.http.get(url);
  }

  /**
   * add Notify Event
   * @param nitifyObj
   */
  addNotifyEvent(notifyObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/notify/addNotifyEvent`;
    let options = {
      observe: 'response' as 'response',
      responseType: 'json' as 'text'
    }
    return this.http.post(url, notifyObj, options);
  }

  /**
   * get all notifyEvent By SubScriber
   * @param subscriber
   */
  getNotifyEvent(subscriber: string, userType: string): Observable<any> {
    const url = `${environment.notificationUrl}/notifyEvent/${subscriber}`;
    const header = new HttpHeaders({'userType' : userType});
    return this.http.get(url, {headers: header});
  }

  /**
   * get user subscribe items by filter
   * @param filterObj filter condition
   * @param subscriber own user login account
   * @param userType userType: example: SA
   */
  getUserSubscribe(filterObj: any, subscriber: string, userType: string): Observable<any>{
    const url = `${environment.notificationUrl}/notifyEvent/userSubscribe/${subscriber}`;
    const header = new HttpHeaders({'userType' : userType});
    return this.http.post(url, filterObj, {headers: header});
  }

  /**
   * delete NotifyEvent by seqNo
   * @param seqNo
   */
  deleteNotifyEvent(seqNo: number): Observable<any> {
    const url = `${environment.notificationUrl}/notifyEvent/${seqNo}`;
    return this.http.delete(url);
  }

  /**
   * update NotifyEvent
   * @param updateObject
   */
  updateNotifyEvent(updateObject: any): Observable<any> {
    const url = `${environment.notificationUrl}/notifyEvent`;
    let options = {
      observe: 'response' as 'response',
      responseType: 'json' as 'text'
    }
    return this.http.put(url, updateObject, options);
  }



  getCustomerOptionsByKey(key?: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/customer/getCustomerOptionsByKey/${key}`;
    return this.http.get(url);
  }

  getCustomerOptionsByFilter(conText?: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/customer/getCustomerOptionsByFilter`;
    return this.http.post(url,conText);
  }

  /**
   * Get Notify Event Values for Personal Email Subscription
   */
   getSubscribableEventValues(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/notify/eventValue`;
    return this.http.get(url);
  }

  getUserGroupSubscriptionNotifyEventOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/notify/getUserGroupSubscriptionNotifyEventOptions`;
    return this.http.post(url, null);
  }

  getEventPermission(eventPermissionRequest: any, lang: string): Observable<any> {
    const url = `${environment.notificationUrl}/notifyEvent/eventPermission/${lang}`;

    return this.http.post(url, eventPermissionRequest);
  }
}
